import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Save } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { Panel } from "./shared";

const inp = "h-11 w-full px-3 bg-[#090D16] border border-[#334155] rounded-md focus:outline-none focus:border-[#F59E0B] font-mono text-sm";
const Lbl = ({ t, children }) => <label className="flex flex-col gap-1"><span className="font-mono text-[10px] tracking-[0.2em] text-[#6B7280]">{t}</span>{children}</label>;

export default function POEmailTemplate() {
  const [f, setF] = useState(null);
  useEffect(() => { api.get("/po-email/settings").then((r) => setF({ subject_template: r.data.subject_template || "", body_template: r.data.body_template || "" })); }, []);
  if (!f) return <Panel className="p-6 font-mono text-[#6B7280]">LOADING…</Panel>;
  const save = async () => {
    try { const r = await api.put("/po-email/settings", f); setF({ subject_template: r.data.subject_template, body_template: r.data.body_template }); toast.success("PO email template saved"); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Panel className="p-6 max-w-4xl space-y-4" data-testid="po-email-template">
      <p className="text-sm text-[#9CA3AF]">The message sent to suppliers with each PO PDF. Mail server settings live in Integrations → Email.</p>
      <Lbl t="SUBJECT TEMPLATE"><input data-testid="po-email-subject_template" value={f.subject_template} onChange={(e) => setF({ ...f, subject_template: e.target.value })} className={inp} /></Lbl>
      <Lbl t="BODY TEMPLATE"><textarea data-testid="po-email-body_template" rows={10} value={f.body_template} onChange={(e) => setF({ ...f, body_template: e.target.value })} className={`${inp} h-auto py-2`} /></Lbl>
      <div className="font-mono text-[10px] text-[#6B7280]">PLACEHOLDERS: {"{po_number} {supplier} {contact} {total} {needed_by} {lines} {company}"}</div>
      <button data-testid="po-email-template-save-btn" onClick={save} className="h-12 px-6 rounded-md bg-[#F59E0B] text-[#090D16] font-bold flex items-center gap-2"><Save className="w-4 h-4" />Save Email Template</button>
    </Panel>
  );
}
